import * as React from 'react';
import {FormField} from "./data/reviewForm";

export type Text = {
    [key: string]: string | FormField[];
};

export const TextContext: React.Context<Text> = React.createContext<Text>({});
